const ADD_CART_ITEM = 'ADD_CART_ITEM';
const UPDATE_CART = 'UPDATE_CART';
const REMOVE_CART_ITEM = 'REMOVE_CART_ITEM';
const SUBSCRIPTION_DETAILS_BY_ID = 'SUBSCRIPTION_DETAILS_BY_ID';
const REQUEST = 'REQUEST';
const FAIL = 'FAIL';
const SET_ORDER_DETAILS = 'SET_ORDER_DETAILS';
const SET_MULTIPLE_CARDS = 'SET_MULTIPLE_CARDS';
const SET_CREDIT_CARD = 'SET_CREDIT_CARD';
const SET_SOURCE_ID = 'SET_SOURCE_ID';
const IS_FETCHING = 'IS_FETCHING';
const CHECKOUT_PAYMENT_ERROR = 'CHECKOUT_PAYMENT_ERROR';
const SET_PROGRAM_PRODUCTS = 'SET_PROGRAM_PRODUCTS';

export {
  ADD_CART_ITEM,
  UPDATE_CART,
  REMOVE_CART_ITEM,
  SUBSCRIPTION_DETAILS_BY_ID,
  REQUEST,
  FAIL,
  SET_ORDER_DETAILS,
  SET_MULTIPLE_CARDS,
  SET_CREDIT_CARD,
  SET_SOURCE_ID,
  IS_FETCHING,
  CHECKOUT_PAYMENT_ERROR,
  SET_PROGRAM_PRODUCTS,
};
